import { useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useSearchParams } from '../../campaigns/hooks/useSearchParams';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

export const useSavePaymentInfo = () => {
  const query = useSearchParams();
  const sessionId = query.get('session_id');
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation('broadcasts');

  const savePaymentInfo = () =>
    api({
      method: 'post',
      url: `/api/client_admin/broadcasts/payments/save_payment_info`,
      data: { session_id: sessionId },
    });

  const { mutate } = useMutation(savePaymentInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries(['broadcastMessages']);
      queryClient.invalidateQueries(['boardSettings']);
      showSuccess({
        content: t('billing.upgrade'),
      });
    },
  });

  useEffect(() => {
    if (sessionId) mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);
};
